export const projections = {
  "1": {
    "label": "GEOGRAPHIC COORDINATE SYSTEMS (Lat/Lon)",
    "groups": {
      "1.1": {
        "label": "World",
        "srids": [
          {
            "name": "WGS 84",
            "epsg": 4326
          }
        ]
      },
      "1.2": {
        "label": "North America",
        "srids": [
          {
            "name": "NAD83",
            "epsg": 4269
          }
        ]
      }
    }
  },
  "2": {
    "label": "UTM ZONES",
    "groups": {
      "2.1": {
        "label": "WGS 84 / UTM North (Zones 1N–60N)",
        "srids": [
          {
            "name": "WGS 84 / UTM zone 1N",
            "epsg": 32601
          },
          {
            "name": "WGS 84 / UTM zone 2N",
            "epsg": 32602
          },
          {
            "name": "WGS 84 / UTM zone 3N",
            "epsg": 32603
          },
          {
            "name": "WGS 84 / UTM zone 4N",
            "epsg": 32604
          },
          {
            "name": "WGS 84 / UTM zone 5N",
            "epsg": 32605
          },
          {
            "name": "WGS 84 / UTM zone 6N",
            "epsg": 32606
          },
          {
            "name": "WGS 84 / UTM zone 7N",
            "epsg": 32607
          },
          {
            "name": "WGS 84 / UTM zone 8N",
            "epsg": 32608
          },
          {
            "name": "WGS 84 / UTM zone 9N",
            "epsg": 32609
          },
          {
            "name": "WGS 84 / UTM zone 10N",
            "epsg": 32610
          },
          {
            "name": "WGS 84 / UTM zone 11N",
            "epsg": 32611
          },
          {
            "name": "WGS 84 / UTM zone 12N",
            "epsg": 32612
          },
          {
            "name": "WGS 84 / UTM zone 13N",
            "epsg": 32613
          },
          {
            "name": "WGS 84 / UTM zone 14N",
            "epsg": 32614
          },
          {
            "name": "WGS 84 / UTM zone 15N",
            "epsg": 32615
          },
          {
            "name": "WGS 84 / UTM zone 16N",
            "epsg": 32616
          },
          {
            "name": "WGS 84 / UTM zone 17N",
            "epsg": 32617
          },
          {
            "name": "WGS 84 / UTM zone 18N",
            "epsg": 32618
          },
          {
            "name": "WGS 84 / UTM zone 19N",
            "epsg": 32619
          },
          {
            "name": "WGS 84 / UTM zone 20N",
            "epsg": 32620
          },
          {
            "name": "WGS 84 / UTM zone 21N",
            "epsg": 32621
          },
          {
            "name": "WGS 84 / UTM zone 22N",
            "epsg": 32622
          },
          {
            "name": "WGS 84 / UTM zone 23N",
            "epsg": 32623
          },
          {
            "name": "WGS 84 / UTM zone 24N",
            "epsg": 32624
          },
          {
            "name": "WGS 84 / UTM zone 25N",
            "epsg": 32625
          },
          {
            "name": "WGS 84 / UTM zone 26N",
            "epsg": 32626
          },
          {
            "name": "WGS 84 / UTM zone 27N",
            "epsg": 32627
          },
          {
            "name": "WGS 84 / UTM zone 28N",
            "epsg": 32628
          },
          {
            "name": "WGS 84 / UTM zone 29N",
            "epsg": 32629
          },
          {
            "name": "WGS 84 / UTM zone 30N",
            "epsg": 32630
          },
          {
            "name": "WGS 84 / UTM zone 31N",
            "epsg": 32631
          },
          {
            "name": "WGS 84 / UTM zone 32N",
            "epsg": 32632
          },
          {
            "name": "WGS 84 / UTM zone 33N",
            "epsg": 32633
          },
          {
            "name": "WGS 84 / UTM zone 34N",
            "epsg": 32634
          },
          {
            "name": "WGS 84 / UTM zone 35N",
            "epsg": 32635
          },
          {
            "name": "WGS 84 / UTM zone 36N",
            "epsg": 32636
          },
          {
            "name": "WGS 84 / UTM zone 37N",
            "epsg": 32637
          },
          {
            "name": "WGS 84 / UTM zone 38N",
            "epsg": 32638
          },
          {
            "name": "WGS 84 / UTM zone 39N",
            "epsg": 32639
          },
          {
            "name": "WGS 84 / UTM zone 40N",
            "epsg": 32640
          },
          {
            "name": "WGS 84 / UTM zone 41N",
            "epsg": 32641
          },
          {
            "name": "WGS 84 / UTM zone 42N",
            "epsg": 32642
          },
          {
            "name": "WGS 84 / UTM zone 43N",
            "epsg": 32643
          },
          {
            "name": "WGS 84 / UTM zone 44N",
            "epsg": 32644
          },
          {
            "name": "WGS 84 / UTM zone 45N",
            "epsg": 32645
          },
          {
            "name": "WGS 84 / UTM zone 46N",
            "epsg": 32646
          },
          {
            "name": "WGS 84 / UTM zone 47N",
            "epsg": 32647
          },
          {
            "name": "WGS 84 / UTM zone 48N",
            "epsg": 32648
          },
          {
            "name": "WGS 84 / UTM zone 49N",
            "epsg": 32649
          },
          {
            "name": "WGS 84 / UTM zone 50N",
            "epsg": 32650
          },
          {
            "name": "WGS 84 / UTM zone 51N",
            "epsg": 32651
          },
          {
            "name": "WGS 84 / UTM zone 52N",
            "epsg": 32652
          },
          {
            "name": "WGS 84 / UTM zone 53N",
            "epsg": 32653
          },
          {
            "name": "WGS 84 / UTM zone 54N",
            "epsg": 32654
          },
          {
            "name": "WGS 84 / UTM zone 55N",
            "epsg": 32655
          },
          {
            "name": "WGS 84 / UTM zone 56N",
            "epsg": 32656
          },
          {
            "name": "WGS 84 / UTM zone 57N",
            "epsg": 32657
          },
          {
            "name": "WGS 84 / UTM zone 58N",
            "epsg": 32658
          },
          {
            "name": "WGS 84 / UTM zone 59N",
            "epsg": 32659
          },
          {
            "name": "WGS 84 / UTM zone 60N",
            "epsg": 32660
          }
        ]
      },
      "2.2": {
        "label": "WGS 84 / UTM South (Zones 1S–60S)",
        "srids": [
          {
            "name": "WGS 84 / UTM zone 1S",
            "epsg": 32701
          },
          {
            "name": "WGS 84 / UTM zone 2S",
            "epsg": 32702
          },
          {
            "name": "WGS 84 / UTM zone 3S",
            "epsg": 32703
          },
          {
            "name": "WGS 84 / UTM zone 4S",
            "epsg": 32704
          },
          {
            "name": "WGS 84 / UTM zone 5S",
            "epsg": 32705
          },
          {
            "name": "WGS 84 / UTM zone 6S",
            "epsg": 32706
          },
          {
            "name": "WGS 84 / UTM zone 7S",
            "epsg": 32707
          },
          {
            "name": "WGS 84 / UTM zone 8S",
            "epsg": 32708
          },
          {
            "name": "WGS 84 / UTM zone 9S",
            "epsg": 32709
          },
          {
            "name": "WGS 84 / UTM zone 10S",
            "epsg": 32710
          },
          {
            "name": "WGS 84 / UTM zone 11S",
            "epsg": 32711
          },
          {
            "name": "WGS 84 / UTM zone 12S",
            "epsg": 32712
          },
          {
            "name": "WGS 84 / UTM zone 13S",
            "epsg": 32713
          },
          {
            "name": "WGS 84 / UTM zone 14S",
            "epsg": 32714
          },
          {
            "name": "WGS 84 / UTM zone 15S",
            "epsg": 32715
          },
          {
            "name": "WGS 84 / UTM zone 16S",
            "epsg": 32716
          },
          {
            "name": "WGS 84 / UTM zone 17S",
            "epsg": 32717
          },
          {
            "name": "WGS 84 / UTM zone 18S",
            "epsg": 32718
          },
          {
            "name": "WGS 84 / UTM zone 19S",
            "epsg": 32719
          },
          {
            "name": "WGS 84 / UTM zone 20S",
            "epsg": 32720
          },
          {
            "name": "WGS 84 / UTM zone 21S",
            "epsg": 32721
          },
          {
            "name": "WGS 84 / UTM zone 22S",
            "epsg": 32722
          },
          {
            "name": "WGS 84 / UTM zone 23S",
            "epsg": 32723
          },
          {
            "name": "WGS 84 / UTM zone 24S",
            "epsg": 32724
          },
          {
            "name": "WGS 84 / UTM zone 25S",
            "epsg": 32725
          },
          {
            "name": "WGS 84 / UTM zone 26S",
            "epsg": 32726
          },
          {
            "name": "WGS 84 / UTM zone 27S",
            "epsg": 32727
          },
          {
            "name": "WGS 84 / UTM zone 28S",
            "epsg": 32728
          },
          {
            "name": "WGS 84 / UTM zone 29S",
            "epsg": 32729
          },
          {
            "name": "WGS 84 / UTM zone 30S",
            "epsg": 32730
          },
          {
            "name": "WGS 84 / UTM zone 31S",
            "epsg": 32731
          },
          {
            "name": "WGS 84 / UTM zone 32S",
            "epsg": 32732
          },
          {
            "name": "WGS 84 / UTM zone 33S",
            "epsg": 32733
          },
          {
            "name": "WGS 84 / UTM zone 34S",
            "epsg": 32734
          },
          {
            "name": "WGS 84 / UTM zone 35S",
            "epsg": 32735
          },
          {
            "name": "WGS 84 / UTM zone 36S",
            "epsg": 32736
          },
          {
            "name": "WGS 84 / UTM zone 37S",
            "epsg": 32737
          },
          {
            "name": "WGS 84 / UTM zone 38S",
            "epsg": 32738
          },
          {
            "name": "WGS 84 / UTM zone 39S",
            "epsg": 32739
          },
          {
            "name": "WGS 84 / UTM zone 40S",
            "epsg": 32740
          },
          {
            "name": "WGS 84 / UTM zone 41S",
            "epsg": 32741
          },
          {
            "name": "WGS 84 / UTM zone 42S",
            "epsg": 32742
          },
          {
            "name": "WGS 84 / UTM zone 43S",
            "epsg": 32743
          },
          {
            "name": "WGS 84 / UTM zone 44S",
            "epsg": 32744
          },
          {
            "name": "WGS 84 / UTM zone 45S",
            "epsg": 32745
          },
          {
            "name": "WGS 84 / UTM zone 46S",
            "epsg": 32746
          },
          {
            "name": "WGS 84 / UTM zone 47S",
            "epsg": 32747
          },
          {
            "name": "WGS 84 / UTM zone 48S",
            "epsg": 32748
          },
          {
            "name": "WGS 84 / UTM zone 49S",
            "epsg": 32749
          },
          {
            "name": "WGS 84 / UTM zone 50S",
            "epsg": 32750
          },
          {
            "name": "WGS 84 / UTM zone 51S",
            "epsg": 32751
          },
          {
            "name": "WGS 84 / UTM zone 52S",
            "epsg": 32752
          },
          {
            "name": "WGS 84 / UTM zone 53S",
            "epsg": 32753
          },
          {
            "name": "WGS 84 / UTM zone 54S",
            "epsg": 32754
          },
          {
            "name": "WGS 84 / UTM zone 55S",
            "epsg": 32755
          },
          {
            "name": "WGS 84 / UTM zone 56S",
            "epsg": 32756
          },
          {
            "name": "WGS 84 / UTM zone 57S",
            "epsg": 32757
          },
          {
            "name": "WGS 84 / UTM zone 58S",
            "epsg": 32758
          },
          {
            "name": "WGS 84 / UTM zone 59S",
            "epsg": 32759
          },
          {
            "name": "WGS 84 / UTM zone 60S",
            "epsg": 32760
          }
        ]
      },
      "2.3": {
        "label": "NAD 1983 / UTM (Zones 1N–23N)",
        "srids": [
          {
            "name": "NAD83 / UTM zone 1N",
            "epsg": 26901
          },
          {
            "name": "NAD83 / UTM zone 2N",
            "epsg": 26902
          },
          {
            "name": "NAD83 / UTM zone 3N",
            "epsg": 26903
          },
          {
            "name": "NAD83 / UTM zone 4N",
            "epsg": 26904
          },
          {
            "name": "NAD83 / UTM zone 5N",
            "epsg": 26905
          },
          {
            "name": "NAD83 / UTM zone 6N",
            "epsg": 26906
          },
          {
            "name": "NAD83 / UTM zone 7N",
            "epsg": 26907
          },
          {
            "name": "NAD83 / UTM zone 8N",
            "epsg": 26908
          },
          {
            "name": "NAD83 / UTM zone 9N",
            "epsg": 26909
          },
          {
            "name": "NAD83 / UTM zone 10N",
            "epsg": 26910
          },
          {
            "name": "NAD83 / UTM zone 11N",
            "epsg": 26911
          },
          {
            "name": "NAD83 / UTM zone 12N",
            "epsg": 26912
          },
          {
            "name": "NAD83 / UTM zone 13N",
            "epsg": 26913
          },
          {
            "name": "NAD83 / UTM zone 14N",
            "epsg": 26914
          },
          {
            "name": "NAD83 / UTM zone 15N",
            "epsg": 26915
          },
          {
            "name": "NAD83 / UTM zone 16N",
            "epsg": 26916
          },
          {
            "name": "NAD83 / UTM zone 17N",
            "epsg": 26917
          },
          {
            "name": "NAD83 / UTM zone 18N",
            "epsg": 26918
          },
          {
            "name": "NAD83 / UTM zone 19N",
            "epsg": 26919
          },
          {
            "name": "NAD83 / UTM zone 20N",
            "epsg": 26920
          },
          {
            "name": "NAD83 / UTM zone 21N",
            "epsg": 26921
          },
          {
            "name": "NAD83 / UTM zone 22N",
            "epsg": 26922
          },
          {
            "name": "NAD83 / UTM zone 23N",
            "epsg": 26923
          }
        ]
      }
    }
  },
  "3": {
    "label": "NORTH AMERICA — CANADA",
    "groups": {
      "3.1": {
        "label": "Canada-Wide",
        "srids": [
          {
            "name": "NAD83 / Canada Atlas Lambert",
            "epsg": 3978
          },
          {
            "name": "NAD83(CSRS) / Canada Atlas Lambert",
            "epsg": 3979
          },
          {
            "name": "NAD83 / Statistics Canada Lambert",
            "epsg": 3347
          }
        ]
      },
      "3.2": {
        "label": "NAD83(CSRS) / UTM (Survey-Grade)",
        "srids": [
          {
            "name": "NAD83(CSRS) / UTM zone 7N",
            "epsg": 3154
          },
          {
            "name": "NAD83(CSRS) / UTM zone 8N",
            "epsg": 3155
          },
          {
            "name": "NAD83(CSRS) / UTM zone 9N",
            "epsg": 3156
          },
          {
            "name": "NAD83(CSRS) / UTM zone 10N",
            "epsg": 3157
          },
          {
            "name": "NAD83(CSRS) / UTM zone 11N",
            "epsg": 2955
          },
          {
            "name": "NAD83(CSRS) / UTM zone 12N",
            "epsg": 2956
          },
          {
            "name": "NAD83(CSRS) / UTM zone 13N",
            "epsg": 2957
          },
          {
            "name": "NAD83(CSRS) / UTM zone 14N",
            "epsg": 3158
          },
          {
            "name": "NAD83(CSRS) / UTM zone 15N",
            "epsg": 3159
          },
          {
            "name": "NAD83(CSRS) / UTM zone 16N",
            "epsg": 3160
          },
          {
            "name": "NAD83(CSRS) / UTM zone 17N",
            "epsg": 2958
          },
          {
            "name": "NAD83(CSRS) / UTM zone 18N",
            "epsg": 2959
          },
          {
            "name": "NAD83(CSRS) / UTM zone 19N",
            "epsg": 2960
          },
          {
            "name": "NAD83(CSRS) / UTM zone 20N",
            "epsg": 2961
          },
          {
            "name": "NAD83(CSRS) / UTM zone 21N",
            "epsg": 2962
          },
          {
            "name": "NAD83(CSRS) / UTM zone 22N",
            "epsg": 3761
          }
        ]
      },
      "3.3": {
        "label": "British Columbia",
        "srids": [
          {
            "name": "NAD83 / BC Albers",
            "epsg": 3005
          },
          {
            "name": "NAD83(CSRS) / BC Albers",
            "epsg": 3153
          }
        ]
      },
      "3.4": {
        "label": "Alberta",
        "srids": [
          {
            "name": "NAD83 / Alberta 10-TM (Forest)",
            "epsg": 3400
          },
          {
            "name": "NAD83 / Alberta 10-TM (Resource)",
            "epsg": 3401
          },
          {
            "name": "NAD83 / Alberta 3TM ref merid 111 W",
            "epsg": 3775
          },
          {
            "name": "NAD83 / Alberta 3TM ref merid 114 W",
            "epsg": 3776
          },
          {
            "name": "NAD83 / Alberta 3TM ref merid 117 W",
            "epsg": 3777
          },
          {
            "name": "NAD83 / Alberta 3TM ref merid 120 W",
            "epsg": 3801
          },
          {
            "name": "NAD83(CSRS) / Alberta 3TM ref merid 120 W",
            "epsg": 3802
          },
          {
            "name": "ERROR",
            "epsg": 3803
          },
          {
            "name": "ERROR",
            "epsg": 3804
          },
          {
            "name": "ERROR",
            "epsg": 3805
          }
        ]
      },
      "3.5": {
        "label": "Ontario",
        "srids": [
          {
            "name": "NAD83 / Ontario MNR Lambert",
            "epsg": 3161
          },
          {
            "name": "NAD83(CSRS) / Ontario MNR Lambert",
            "epsg": 3162
          }
        ]
      },
      "3.6": {
        "label": "Quebec (MTM Zones)",
        "srids": [
          {
            "name": "NAD83 / MTM zone 2",
            "epsg": 32182
          },
          {
            "name": "NAD83 / MTM zone 3",
            "epsg": 32183
          },
          {
            "name": "NAD83 / MTM zone 4",
            "epsg": 32184
          },
          {
            "name": "NAD83 / MTM zone 5",
            "epsg": 32185
          },
          {
            "name": "NAD83 / MTM zone 6",
            "epsg": 32186
          },
          {
            "name": "NAD83 / MTM zone 7",
            "epsg": 32187
          },
          {
            "name": "NAD83 / MTM zone 8",
            "epsg": 32188
          },
          {
            "name": "NAD83 / MTM zone 9",
            "epsg": 32189
          },
          {
            "name": "NAD83 / MTM zone 10",
            "epsg": 32190
          }
        ]
      },
      "3.7": {
        "label": "New Brunswick",
        "srids": [
          {
            "name": "NAD83(CSRS) / New Brunswick Stereographic",
            "epsg": 2953
          },
          {
            "name": "NAD83(CSRS98) / New Brunswick Stereo",
            "epsg": 2036
          }
        ]
      },
      "3.8": {
        "label": "PEI",
        "srids": [
          {
            "name": "NAD83(CSRS) / Prince Edward Isl. Stereographic (NAD83)",
            "epsg": 2954
          }
        ]
      }
    }
  },
  "4": {
    "label": "US STATE PLANE — NAD 1983 (Metres)",
    "groups": {
      "4.1": {
        "label": "Alabama",
        "srids": [
          {
            "name": "NAD83 / Alabama East",
            "epsg": 26929
          },
          {
            "name": "NAD83 / Alabama West",
            "epsg": 26930
          }
        ]
      },
      "4.2": {
        "label": "Alaska",
        "srids": [
          {
            "name": "NAD83 / Alaska zone 1",
            "epsg": 26931
          },
          {
            "name": "NAD83 / Alaska zone 2",
            "epsg": 26932
          },
          {
            "name": "NAD83 / Alaska zone 3",
            "epsg": 26933
          },
          {
            "name": "NAD83 / Alaska zone 4",
            "epsg": 26934
          },
          {
            "name": "NAD83 / Alaska zone 5",
            "epsg": 26935
          },
          {
            "name": "NAD83 / Alaska zone 6",
            "epsg": 26936
          },
          {
            "name": "NAD83 / Alaska zone 7",
            "epsg": 26937
          },
          {
            "name": "NAD83 / Alaska zone 8",
            "epsg": 26938
          },
          {
            "name": "NAD83 / Alaska zone 9",
            "epsg": 26939
          },
          {
            "name": "NAD83 / Alaska zone 10",
            "epsg": 26940
          }
        ]
      },
      "4.3": {
        "label": "Arizona",
        "srids": [
          {
            "name": "NAD83 / Arizona East",
            "epsg": 26948
          },
          {
            "name": "NAD83 / Arizona Central",
            "epsg": 26949
          },
          {
            "name": "NAD83 / Arizona West",
            "epsg": 26950
          }
        ]
      },
      "4.4": {
        "label": "Arkansas",
        "srids": [
          {
            "name": "NAD83 / Arkansas North",
            "epsg": 26951
          },
          {
            "name": "NAD83 / Arkansas South",
            "epsg": 26952
          }
        ]
      },
      "4.5": {
        "label": "California",
        "srids": [
          {
            "name": "NAD83 / California zone 1",
            "epsg": 26941
          },
          {
            "name": "NAD83 / California zone 2",
            "epsg": 26942
          },
          {
            "name": "NAD83 / California zone 3",
            "epsg": 26943
          },
          {
            "name": "NAD83 / California zone 4",
            "epsg": 26944
          },
          {
            "name": "NAD83 / California zone 5",
            "epsg": 26945
          },
          {
            "name": "NAD83 / California zone 6",
            "epsg": 26946
          }
        ]
      },
      "4.6": {
        "label": "Colorado",
        "srids": [
          {
            "name": "NAD83 / Colorado North",
            "epsg": 26953
          },
          {
            "name": "NAD83 / Colorado Central",
            "epsg": 26954
          },
          {
            "name": "NAD83 / Colorado South",
            "epsg": 26955
          }
        ]
      },
      "4.7": {
        "label": "Connecticut",
        "srids": [
          {
            "name": "NAD83 / Connecticut",
            "epsg": 26956
          }
        ]
      },
      "4.8": {
        "label": "Delaware",
        "srids": [
          {
            "name": "NAD83 / Delaware",
            "epsg": 26957
          }
        ]
      },
      "4.9": {
        "label": "Florida",
        "srids": [
          {
            "name": "NAD83 / Florida East",
            "epsg": 26958
          },
          {
            "name": "NAD83 / Florida West",
            "epsg": 26959
          },
          {
            "name": "NAD83 / Florida North",
            "epsg": 26960
          }
        ]
      },
      "4.10": {
        "label": "Georgia",
        "srids": [
          {
            "name": "NAD83 / Georgia East",
            "epsg": 26966
          },
          {
            "name": "NAD83 / Georgia West",
            "epsg": 26967
          }
        ]
      },
      "4.11": {
        "label": "Hawaii",
        "srids": [
          {
            "name": "NAD83 / Hawaii zone 1",
            "epsg": 26961
          },
          {
            "name": "NAD83 / Hawaii zone 2",
            "epsg": 26962
          },
          {
            "name": "NAD83 / Hawaii zone 3",
            "epsg": 26963
          },
          {
            "name": "NAD83 / Hawaii zone 4",
            "epsg": 26964
          },
          {
            "name": "NAD83 / Hawaii zone 5",
            "epsg": 26965
          }
        ]
      },
      "4.12": {
        "label": "Idaho",
        "srids": [
          {
            "name": "NAD83 / Idaho East",
            "epsg": 26968
          },
          {
            "name": "NAD83 / Idaho Central",
            "epsg": 26969
          },
          {
            "name": "NAD83 / Idaho West",
            "epsg": 26970
          }
        ]
      },
      "4.13": {
        "label": "Illinois",
        "srids": [
          {
            "name": "NAD83 / Illinois East",
            "epsg": 26971
          },
          {
            "name": "NAD83 / Illinois West",
            "epsg": 26972
          }
        ]
      },
      "4.14": {
        "label": "Indiana",
        "srids": [
          {
            "name": "NAD83 / Indiana East",
            "epsg": 26973
          },
          {
            "name": "NAD83 / Indiana West",
            "epsg": 26974
          }
        ]
      },
      "4.15": {
        "label": "Iowa",
        "srids": [
          {
            "name": "NAD83 / Iowa North",
            "epsg": 26975
          },
          {
            "name": "NAD83 / Iowa South",
            "epsg": 26976
          }
        ]
      },
      "4.16": {
        "label": "Kansas",
        "srids": [
          {
            "name": "NAD83 / Kansas North",
            "epsg": 26977
          },
          {
            "name": "NAD83 / Kansas South",
            "epsg": 26978
          }
        ]
      },
      "4.17": {
        "label": "Kentucky",
        "srids": [
          {
            "name": "NAD83 / Kentucky North",
            "epsg": 2205
          },
          {
            "name": "ED50 / 3-degree Gauss-Kruger zone 9",
            "epsg": 2206
          },
          {
            "name": "NAD83 / Kentucky Single Zone",
            "epsg": 3088
          }
        ]
      },
      "4.18": {
        "label": "Louisiana",
        "srids": [
          {
            "name": "NAD83 / Louisiana North",
            "epsg": 26981
          },
          {
            "name": "NAD83 / Louisiana South",
            "epsg": 26982
          },
          {
            "name": "NAD83 / Louisiana Offshore",
            "epsg": 32199
          }
        ]
      },
      "4.19": {
        "label": "Maine",
        "srids": [
          {
            "name": "NAD83 / Maine East",
            "epsg": 26983
          },
          {
            "name": "NAD83 / Maine West",
            "epsg": 26984
          }
        ]
      },
      "4.20": {
        "label": "Maryland",
        "srids": [
          {
            "name": "NAD83 / Maryland",
            "epsg": 26985
          }
        ]
      },
      "4.21": {
        "label": "Massachusetts",
        "srids": [
          {
            "name": "NAD83 / Massachusetts Mainland",
            "epsg": 26986
          },
          {
            "name": "NAD83 / Massachusetts Island",
            "epsg": 26987
          }
        ]
      },
      "4.22": {
        "label": "Michigan",
        "srids": [
          {
            "name": "NAD83 / Michigan North",
            "epsg": 26988
          },
          {
            "name": "NAD83 / Michigan Central",
            "epsg": 26989
          },
          {
            "name": "NAD83 / Michigan South",
            "epsg": 26990
          }
        ]
      },
      "4.23": {
        "label": "Minnesota",
        "srids": [
          {
            "name": "NAD83 / Minnesota North",
            "epsg": 26991
          },
          {
            "name": "NAD83 / Minnesota Central",
            "epsg": 26992
          },
          {
            "name": "NAD83 / Minnesota South",
            "epsg": 26993
          }
        ]
      },
      "4.24": {
        "label": "Mississippi",
        "srids": [
          {
            "name": "NAD83 / Mississippi East",
            "epsg": 26994
          },
          {
            "name": "NAD83 / Mississippi West",
            "epsg": 26995
          }
        ]
      },
      "4.25": {
        "label": "Missouri",
        "srids": [
          {
            "name": "NAD83 / Missouri East",
            "epsg": 26996
          },
          {
            "name": "NAD83 / Missouri Central",
            "epsg": 26997
          },
          {
            "name": "NAD83 / Missouri West",
            "epsg": 26998
          }
        ]
      },
      "4.26": {
        "label": "Montana",
        "srids": [
          {
            "name": "NAD83 / Montana",
            "epsg": 32100
          }
        ]
      },
      "4.27": {
        "label": "Nebraska",
        "srids": [
          {
            "name": "NAD83 / Nebraska",
            "epsg": 32104
          }
        ]
      },
      "4.28": {
        "label": "Nevada",
        "srids": [
          {
            "name": "NAD83 / Nevada East",
            "epsg": 32107
          },
          {
            "name": "NAD83 / Nevada Central",
            "epsg": 32108
          },
          {
            "name": "NAD83 / Nevada West",
            "epsg": 32109
          }
        ]
      },
      "4.29": {
        "label": "New Hampshire",
        "srids": [
          {
            "name": "NAD83 / New Hampshire",
            "epsg": 32110
          }
        ]
      },
      "4.30": {
        "label": "New Jersey",
        "srids": [
          {
            "name": "NAD83 / New Jersey",
            "epsg": 32111
          }
        ]
      },
      "4.31": {
        "label": "New Mexico",
        "srids": [
          {
            "name": "NAD83 / New Mexico East",
            "epsg": 32112
          },
          {
            "name": "NAD83 / New Mexico Central",
            "epsg": 32113
          },
          {
            "name": "NAD83 / New Mexico West",
            "epsg": 32114
          }
        ]
      },
      "4.32": {
        "label": "New York",
        "srids": [
          {
            "name": "NAD83 / New York East",
            "epsg": 32115
          },
          {
            "name": "NAD83 / New York Central",
            "epsg": 32116
          },
          {
            "name": "NAD83 / New York West",
            "epsg": 32117
          },
          {
            "name": "NAD83 / New York Long Island",
            "epsg": 32118
          }
        ]
      },
      "4.33": {
        "label": "North Carolina",
        "srids": [
          {
            "name": "NAD83 / North Carolina",
            "epsg": 32119
          }
        ]
      },
      "4.34": {
        "label": "North Dakota",
        "srids": [
          {
            "name": "NAD83 / North Dakota North",
            "epsg": 32120
          },
          {
            "name": "NAD83 / North Dakota South",
            "epsg": 32121
          }
        ]
      },
      "4.35": {
        "label": "Ohio",
        "srids": [
          {
            "name": "NAD83 / Ohio North",
            "epsg": 32122
          },
          {
            "name": "NAD83 / Ohio South",
            "epsg": 32123
          }
        ]
      },
      "4.36": {
        "label": "Oklahoma",
        "srids": [
          {
            "name": "NAD83 / Oklahoma North",
            "epsg": 32124
          },
          {
            "name": "NAD83 / Oklahoma South",
            "epsg": 32125
          }
        ]
      },
      "4.37": {
        "label": "Oregon",
        "srids": [
          {
            "name": "NAD83 / Oregon North",
            "epsg": 32126
          },
          {
            "name": "NAD83 / Oregon South",
            "epsg": 32127
          }
        ]
      },
      "4.38": {
        "label": "Pennsylvania",
        "srids": [
          {
            "name": "NAD83 / Pennsylvania North",
            "epsg": 32128
          },
          {
            "name": "NAD83 / Pennsylvania South",
            "epsg": 32129
          }
        ]
      },
      "4.39": {
        "label": "Rhode Island",
        "srids": [
          {
            "name": "NAD83 / Rhode Island",
            "epsg": 32130
          }
        ]
      },
      "4.40": {
        "label": "South Carolina",
        "srids": [
          {
            "name": "NAD83 / South Carolina",
            "epsg": 32133
          }
        ]
      },
      "4.41": {
        "label": "South Dakota",
        "srids": [
          {
            "name": "NAD83 / South Dakota North",
            "epsg": 32134
          },
          {
            "name": "NAD83 / South Dakota South",
            "epsg": 32135
          }
        ]
      },
      "4.42": {
        "label": "Tennessee",
        "srids": [
          {
            "name": "NAD83 / Tennessee",
            "epsg": 32136
          }
        ]
      },
      "4.43": {
        "label": "Texas",
        "srids": [
          {
            "name": "NAD83 / Texas North",
            "epsg": 32137
          },
          {
            "name": "NAD83 / Texas North Central",
            "epsg": 32138
          },
          {
            "name": "NAD83 / Texas Central",
            "epsg": 32139
          },
          {
            "name": "NAD83 / Texas South Central",
            "epsg": 32140
          },
          {
            "name": "NAD83 / Texas South",
            "epsg": 32141
          }
        ]
      },
      "4.44": {
        "label": "Utah",
        "srids": [
          {
            "name": "NAD83 / Utah North",
            "epsg": 32142
          },
          {
            "name": "NAD83 / Utah Central",
            "epsg": 32143
          },
          {
            "name": "NAD83 / Utah South",
            "epsg": 32144
          }
        ]
      },
      "4.45": {
        "label": "Vermont",
        "srids": [
          {
            "name": "NAD83 / Vermont",
            "epsg": 32145
          }
        ]
      },
      "4.46": {
        "label": "Virginia",
        "srids": [
          {
            "name": "NAD83 / Virginia North",
            "epsg": 32146
          },
          {
            "name": "NAD83 / Virginia South",
            "epsg": 32147
          }
        ]
      },
      "4.47": {
        "label": "Washington",
        "srids": [
          {
            "name": "NAD83 / Washington North",
            "epsg": 32148
          },
          {
            "name": "NAD83 / Washington South",
            "epsg": 32149
          }
        ]
      },
      "4.48": {
        "label": "West Virginia",
        "srids": [
          {
            "name": "NAD83 / West Virginia North",
            "epsg": 32150
          },
          {
            "name": "NAD83 / West Virginia South",
            "epsg": 32151
          }
        ]
      },
      "4.49": {
        "label": "Wisconsin",
        "srids": [
          {
            "name": "NAD83 / Wisconsin North",
            "epsg": 32152
          },
          {
            "name": "NAD83 / Wisconsin Central",
            "epsg": 32153
          },
          {
            "name": "NAD83 / Wisconsin South",
            "epsg": 32154
          }
        ]
      },
      "4.50": {
        "label": "Wyoming",
        "srids": [
          {
            "name": "NAD83 / Wyoming East",
            "epsg": 32155
          },
          {
            "name": "NAD83 / Wyoming East Central",
            "epsg": 32156
          },
          {
            "name": "NAD83 / Wyoming West Central",
            "epsg": 32157
          },
          {
            "name": "NAD83 / Wyoming West",
            "epsg": 32158
          }
        ]
      },
      "4.51": {
        "label": "Puerto Rico / Virgin Islands",
        "srids": [
          {
            "name": "NAD83 / Puerto Rico & Virgin Is.",
            "epsg": 32161
          }
        ]
      },
      "4.52": {
        "label": "Guam",
        "srids": [
          {
            "name": "ERROR",
            "epsg": 32162
          }
        ]
      }
    }
  },
  "5": {
    "label": "US STATE PLANE — NAD 1983 (US Survey Feet)",
    "groups": {
      "5.1": {
        "label": "Alabama",
        "srids": [
          {
            "name": "NAD83(HARN) / Alabama East",
            "epsg": 2759
          },
          {
            "name": "NAD83(HARN) / Alabama West",
            "epsg": 2760
          }
        ]
      },
      "5.2": {
        "label": "Alaska",
        "srids": [
          {
            "name": "NAD83(HARN) / Hawaii zone 3",
            "epsg": 2784
          },
          {
            "name": "NAD83(HARN) / Hawaii zone 4",
            "epsg": 2785
          },
          {
            "name": "NAD83(HARN) / Hawaii zone 5",
            "epsg": 2786
          },
          {
            "name": "NAD83(HARN) / Idaho East",
            "epsg": 2787
          },
          {
            "name": "NAD83(HARN) / Idaho Central",
            "epsg": 2788
          },
          {
            "name": "NAD83(HARN) / Idaho West",
            "epsg": 2789
          },
          {
            "name": "NAD83(HARN) / Illinois East",
            "epsg": 2790
          },
          {
            "name": "NAD83(HARN) / Illinois West",
            "epsg": 2791
          },
          {
            "name": "NAD83(HARN) / Indiana East",
            "epsg": 2792
          },
          {
            "name": "NAD83(HARN) / Indiana West",
            "epsg": 2793
          }
        ]
      },
      "5.3": {
        "label": "Arizona",
        "srids": [
          {
            "name": "NAD83 / Arizona East (ft)",
            "epsg": 2222
          },
          {
            "name": "NAD83 / Arizona Central (ft)",
            "epsg": 2223
          },
          {
            "name": "NAD83 / Arizona West (ft)",
            "epsg": 2224
          }
        ]
      },
      "5.4": {
        "label": "Arkansas",
        "srids": [
          {
            "name": "NAD83 / Arkansas North (ftUS)",
            "epsg": 3433
          },
          {
            "name": "NAD83 / Arkansas South (ftUS)",
            "epsg": 3434
          }
        ]
      },
      "5.5": {
        "label": "California",
        "srids": [
          {
            "name": "NAD83 / California zone 1 (ftUS)",
            "epsg": 2225
          },
          {
            "name": "NAD83 / California zone 2 (ftUS)",
            "epsg": 2226
          },
          {
            "name": "NAD83 / California zone 3 (ftUS)",
            "epsg": 2227
          },
          {
            "name": "NAD83 / California zone 4 (ftUS)",
            "epsg": 2228
          },
          {
            "name": "NAD83 / California zone 5 (ftUS)",
            "epsg": 2229
          },
          {
            "name": "NAD83 / California zone 6 (ftUS)",
            "epsg": 2230
          }
        ]
      },
      "5.6": {
        "label": "Colorado",
        "srids": [
          {
            "name": "NAD83 / Colorado North (ftUS)",
            "epsg": 2231
          },
          {
            "name": "NAD83 / Colorado Central (ftUS)",
            "epsg": 2232
          },
          {
            "name": "NAD83 / Colorado South (ftUS)",
            "epsg": 2233
          }
        ]
      },
      "5.7": {
        "label": "Connecticut",
        "srids": [
          {
            "name": "NAD83 / Connecticut (ftUS)",
            "epsg": 2234
          }
        ]
      },
      "5.8": {
        "label": "Delaware",
        "srids": [
          {
            "name": "NAD83 / Delaware (ftUS)",
            "epsg": 2235
          }
        ]
      },
      "5.9": {
        "label": "Florida",
        "srids": [
          {
            "name": "NAD83 / Florida East (ftUS)",
            "epsg": 2236
          },
          {
            "name": "NAD83 / Florida West (ftUS)",
            "epsg": 2237
          },
          {
            "name": "NAD83 / Florida North (ftUS)",
            "epsg": 2238
          }
        ]
      },
      "5.10": {
        "label": "Georgia",
        "srids": [
          {
            "name": "NAD83 / Georgia East (ftUS)",
            "epsg": 2239
          },
          {
            "name": "NAD83 / Georgia West (ftUS)",
            "epsg": 2240
          }
        ]
      },
      "5.11": {
        "label": "Hawaii",
        "srids": [
          {
            "name": "NAD83(HARN) / Arizona East",
            "epsg": 2761
          },
          {
            "name": "NAD83(HARN) / Arizona Central",
            "epsg": 2762
          },
          {
            "name": "NAD83(HARN) / Arizona West",
            "epsg": 2763
          },
          {
            "name": "NAD83(HARN) / Arkansas North",
            "epsg": 2764
          },
          {
            "name": "NAD83(HARN) / Arkansas South",
            "epsg": 2765
          }
        ]
      },
      "5.12": {
        "label": "Idaho",
        "srids": [
          {
            "name": "NAD83 / Idaho East (ftUS)",
            "epsg": 2241
          },
          {
            "name": "NAD83 / Idaho Central (ftUS)",
            "epsg": 2242
          },
          {
            "name": "NAD83 / Idaho West (ftUS)",
            "epsg": 2243
          }
        ]
      },
      "5.13": {
        "label": "Illinois",
        "srids": [
          {
            "name": "NAD83 / Illinois East (ftUS)",
            "epsg": 3435
          },
          {
            "name": "NAD83 / Illinois West (ftUS)",
            "epsg": 3436
          }
        ]
      },
      "5.14": {
        "label": "Indiana",
        "srids": [
          {
            "name": "NAD83 / Indiana East (ftUS)",
            "epsg": 2965
          },
          {
            "name": "NAD83 / Indiana West (ftUS)",
            "epsg": 2966
          }
        ]
      },
      "5.15": {
        "label": "Iowa",
        "srids": [
          {
            "name": "NAD83 / Iowa North (ftUS)",
            "epsg": 3417
          },
          {
            "name": "NAD83 / Iowa South (ftUS)",
            "epsg": 3418
          }
        ]
      },
      "5.16": {
        "label": "Kansas",
        "srids": [
          {
            "name": "NAD83 / Kansas North (ftUS)",
            "epsg": 3419
          },
          {
            "name": "NAD83 / Kansas South (ftUS)",
            "epsg": 3420
          }
        ]
      },
      "5.17": {
        "label": "Kentucky",
        "srids": [
          {
            "name": "NAD83 / Kentucky North (ftUS)",
            "epsg": 2246
          },
          {
            "name": "NAD83 / Kentucky South (ftUS)",
            "epsg": 2247
          },
          {
            "name": "NAD83 / Kentucky Single Zone (ftUS)",
            "epsg": 3089
          }
        ]
      },
      "5.18": {
        "label": "Louisiana",
        "srids": [
          {
            "name": "NAD83 / Louisiana North (ftUS)",
            "epsg": 3451
          },
          {
            "name": "NAD83 / Louisiana South (ftUS)",
            "epsg": 3452
          },
          {
            "name": "NAD83 / Louisiana Offshore (ftUS)",
            "epsg": 3453
          }
        ]
      },
      "5.19": {
        "label": "Maine",
        "srids": [
          {
            "name": "NAD83 / Maine East (ftUS)",
            "epsg": 26847
          },
          {
            "name": "NAD83 / Maine West (ftUS)",
            "epsg": 26848
          }
        ]
      },
      "5.20": {
        "label": "Maryland",
        "srids": [
          {
            "name": "NAD83 / Maryland (ftUS)",
            "epsg": 2248
          }
        ]
      },
      "5.21": {
        "label": "Massachusetts",
        "srids": [
          {
            "name": "NAD83 / Massachusetts Mainland (ftUS)",
            "epsg": 2249
          },
          {
            "name": "NAD83 / Massachusetts Island (ftUS)",
            "epsg": 2250
          }
        ]
      },
      "5.22": {
        "label": "Michigan",
        "srids": [
          {
            "name": "NAD83 / Michigan North (ft)",
            "epsg": 2251
          },
          {
            "name": "NAD83 / Michigan Central (ft)",
            "epsg": 2252
          },
          {
            "name": "NAD83 / Michigan South (ft)",
            "epsg": 2253
          }
        ]
      },
      "5.23": {
        "label": "Minnesota",
        "srids": [
          {
            "name": "NAD83 / Minnesota North (ftUS)",
            "epsg": 26849
          },
          {
            "name": "NAD83 / Minnesota Central (ftUS)",
            "epsg": 26850
          },
          {
            "name": "NAD83 / Minnesota South (ftUS)",
            "epsg": 26851
          }
        ]
      },
      "5.24": {
        "label": "Mississippi",
        "srids": [
          {
            "name": "NAD83 / Mississippi East (ftUS)",
            "epsg": 2254
          },
          {
            "name": "NAD83 / Mississippi West (ftUS)",
            "epsg": 2255
          }
        ]
      },
      "5.25": {
        "label": "Missouri",
        "srids": [
          {
            "name": "NAD83 / Missouri East (ftUS)",
            "epsg": 102696
          },
          {
            "name": "NAD83 / Missouri Central (ftUS)",
            "epsg": 102697
          },
          {
            "name": "NAD83 / Missouri West (ftUS)",
            "epsg": 102698
          }
        ]
      },
      "5.26": {
        "label": "Montana",
        "srids": [
          {
            "name": "NAD83 / Montana (ft)",
            "epsg": 2256
          }
        ]
      },
      "5.27": {
        "label": "Nebraska",
        "srids": [
          {
            "name": "NAD83 / Nebraska (ftUS)",
            "epsg": 26852
          }
        ]
      },
      "5.28": {
        "label": "Nevada",
        "srids": [
          {
            "name": "NAD83 / Nevada East (ftUS)",
            "epsg": 3421
          },
          {
            "name": "NAD83 / Nevada Central (ftUS)",
            "epsg": 3422
          },
          {
            "name": "NAD83 / Nevada West (ftUS)",
            "epsg": 3423
          }
        ]
      },
      "5.29": {
        "label": "New Hampshire",
        "srids": [
          {
            "name": "NAD83 / New Hampshire (ftUS)",
            "epsg": 3437
          }
        ]
      },
      "5.30": {
        "label": "New Jersey",
        "srids": [
          {
            "name": "NAD83 / New Jersey (ftUS)",
            "epsg": 3424
          }
        ]
      },
      "5.31": {
        "label": "New Mexico",
        "srids": [
          {
            "name": "NAD83 / New Mexico East (ftUS)",
            "epsg": 2257
          },
          {
            "name": "NAD83 / New Mexico Central (ftUS)",
            "epsg": 2258
          },
          {
            "name": "NAD83 / New Mexico West (ftUS)",
            "epsg": 2259
          }
        ]
      },
      "5.32": {
        "label": "New York",
        "srids": [
          {
            "name": "NAD83 / New York East (ftUS)",
            "epsg": 2260
          },
          {
            "name": "NAD83 / New York Central (ftUS)",
            "epsg": 2261
          },
          {
            "name": "NAD83 / New York West (ftUS)",
            "epsg": 2262
          },
          {
            "name": "NAD83 / New York Long Island (ftUS)",
            "epsg": 2263
          }
        ]
      },
      "5.33": {
        "label": "North Carolina",
        "srids": [
          {
            "name": "NAD83 / North Carolina (ftUS)",
            "epsg": 2264
          }
        ]
      },
      "5.34": {
        "label": "North Dakota",
        "srids": [
          {
            "name": "NAD83 / North Dakota North (ft)",
            "epsg": 2265
          },
          {
            "name": "NAD83 / North Dakota South (ft)",
            "epsg": 2266
          }
        ]
      },
      "5.35": {
        "label": "Ohio",
        "srids": [
          {
            "name": "NAD83 / Ohio North (ftUS)",
            "epsg": 3734
          },
          {
            "name": "NAD83 / Ohio South (ftUS)",
            "epsg": 3735
          }
        ]
      },
      "5.36": {
        "label": "Oklahoma",
        "srids": [
          {
            "name": "NAD83 / Oklahoma North (ftUS)",
            "epsg": 2267
          },
          {
            "name": "NAD83 / Oklahoma South (ftUS)",
            "epsg": 2268
          }
        ]
      },
      "5.37": {
        "label": "Oregon",
        "srids": [
          {
            "name": "NAD83 / Oregon North (ft)",
            "epsg": 2269
          },
          {
            "name": "NAD83 / Oregon South (ft)",
            "epsg": 2270
          }
        ]
      },
      "5.38": {
        "label": "Pennsylvania",
        "srids": [
          {
            "name": "NAD83 / Pennsylvania North (ftUS)",
            "epsg": 2271
          },
          {
            "name": "NAD83 / Pennsylvania South (ftUS)",
            "epsg": 2272
          }
        ]
      },
      "5.39": {
        "label": "Rhode Island",
        "srids": [
          {
            "name": "NAD83 / Rhode Island (ftUS)",
            "epsg": 3438
          }
        ]
      },
      "5.40": {
        "label": "South Carolina",
        "srids": [
          {
            "name": "NAD83 / South Carolina (ft)",
            "epsg": 2273
          }
        ]
      },
      "5.41": {
        "label": "South Dakota",
        "srids": [
          {
            "name": "NAD83 / South Dakota North (ftUS)",
            "epsg": 3454
          },
          {
            "name": "NAD83 / South Dakota South (ftUS)",
            "epsg": 3455
          }
        ]
      },
      "5.42": {
        "label": "Tennessee",
        "srids": [
          {
            "name": "NAD83 / Tennessee (ftUS)",
            "epsg": 2274
          }
        ]
      },
      "5.43": {
        "label": "Texas",
        "srids": [
          {
            "name": "NAD83 / Texas North (ftUS)",
            "epsg": 2275
          },
          {
            "name": "NAD83 / Texas North Central (ftUS)",
            "epsg": 2276
          },
          {
            "name": "NAD83 / Texas Central (ftUS)",
            "epsg": 2277
          },
          {
            "name": "NAD83 / Texas South Central (ftUS)",
            "epsg": 2278
          },
          {
            "name": "NAD83 / Texas South (ftUS)",
            "epsg": 2279
          }
        ]
      },
      "5.44": {
        "label": "Utah",
        "srids": [
          {
            "name": "NAD83 / Utah North (ftUS)",
            "epsg": 3560
          },
          {
            "name": "NAD83 / Utah Central (ftUS)",
            "epsg": 3566
          },
          {
            "name": "NAD83 / Utah South (ftUS)",
            "epsg": 3567
          }
        ]
      },
      "5.45": {
        "label": "Vermont",
        "srids": [
          {
            "name": "NAD83 / Vermont (ftUS)",
            "epsg": 5646
          }
        ]
      },
      "5.46": {
        "label": "Virginia",
        "srids": [
          {
            "name": "NAD83 / Virginia North (ftUS)",
            "epsg": 2283
          },
          {
            "name": "NAD83 / Virginia South (ftUS)",
            "epsg": 2284
          }
        ]
      },
      "5.47": {
        "label": "Washington",
        "srids": [
          {
            "name": "NAD83 / Washington North (ftUS)",
            "epsg": 2285
          },
          {
            "name": "NAD83 / Washington South (ftUS)",
            "epsg": 2286
          }
        ]
      },
      "5.48": {
        "label": "West Virginia",
        "srids": [
          {
            "name": "NAD83 / West Virginia North (ftUS)",
            "epsg": 26853
          },
          {
            "name": "NAD83 / West Virginia South (ftUS)",
            "epsg": 26854
          }
        ]
      },
      "5.49": {
        "label": "Wisconsin",
        "srids": [
          {
            "name": "NAD83 / Wisconsin North (ftUS)",
            "epsg": 2287
          },
          {
            "name": "NAD83 / Wisconsin Central (ftUS)",
            "epsg": 2288
          },
          {
            "name": "NAD83 / Wisconsin South (ftUS)",
            "epsg": 2289
          }
        ]
      },
      "5.50": {
        "label": "Wyoming",
        "srids": [
          {
            "name": "NAD83 / Wyoming East (ftUS)",
            "epsg": 3736
          },
          {
            "name": "NAD83 / Wyoming East Central (ftUS)",
            "epsg": 3737
          },
          {
            "name": "NAD83 / Wyoming West Central (ftUS)",
            "epsg": 3738
          },
          {
            "name": "NAD83 / Wyoming West (ftUS)",
            "epsg": 3739
          }
        ]
      }
    }
  },
  "6": {
    "label": "US STATE PLANE — NAD 1983 HARN",
    "groups": {
      "6.1": {
        "label": "HARN (Metres)",
        "groups": {
          "6.1.1": {
            "label": "Alabama",
            "srids": [
              {
                "name": "NAD83(HARN) / Alabama East",
                "epsg": 2759
              },
              {
                "name": "NAD83(HARN) / Alabama West",
                "epsg": 2760
              }
            ]
          },
          "6.1.2": {
            "label": "Arizona",
            "srids": [
              {
                "name": "NAD83(HARN) / Arizona East",
                "epsg": 2761
              },
              {
                "name": "NAD83(HARN) / Arizona Central",
                "epsg": 2762
              },
              {
                "name": "NAD83(HARN) / Arizona West",
                "epsg": 2763
              }
            ]
          },
          "6.1.3": {
            "label": "Arkansas",
            "srids": [
              {
                "name": "PSD93 / UTM zone 40N",
                "epsg": 3440
              },
              {
                "name": "NAD83(HARN) / Arkansas North (ftUS)",
                "epsg": 3441
              }
            ]
          },
          "6.1.4": {
            "label": "California",
            "srids": [
              {
                "name": "NAD83(HARN) / California zone 1",
                "epsg": 2766
              },
              {
                "name": "NAD83(HARN) / California zone 2",
                "epsg": 2767
              },
              {
                "name": "NAD83(HARN) / California zone 3",
                "epsg": 2768
              },
              {
                "name": "NAD83(HARN) / California zone 4",
                "epsg": 2769
              },
              {
                "name": "NAD83(HARN) / California zone 5",
                "epsg": 2770
              },
              {
                "name": "NAD83(HARN) / California zone 6",
                "epsg": 2771
              }
            ]
          },
          "6.1.5": {
            "label": "Colorado",
            "srids": [
              {
                "name": "NAD83(HARN) / Colorado North",
                "epsg": 2772
              },
              {
                "name": "NAD83(HARN) / Colorado Central",
                "epsg": 2773
              },
              {
                "name": "NAD83(HARN) / Colorado South",
                "epsg": 2774
              }
            ]
          },
          "6.1.6": {
            "label": "Connecticut",
            "srids": [
              {
                "name": "NAD83(HARN) / Connecticut",
                "epsg": 2775
              }
            ]
          },
          "6.1.7": {
            "label": "Delaware",
            "srids": [
              {
                "name": "NAD83(HARN) / Delaware",
                "epsg": 2776
              }
            ]
          },
          "6.1.8": {
            "label": "Florida",
            "srids": [
              {
                "name": "NAD83(HARN) / Florida East",
                "epsg": 2777
              },
              {
                "name": "NAD83(HARN) / Florida West",
                "epsg": 2778
              },
              {
                "name": "NAD83(HARN) / Florida North",
                "epsg": 2779
              }
            ]
          },
          "6.1.9": {
            "label": "Georgia",
            "srids": [
              {
                "name": "NAD83(HARN) / Georgia East",
                "epsg": 2780
              },
              {
                "name": "NAD83(HARN) / Georgia West",
                "epsg": 2781
              }
            ]
          },
          "6.1.10": {
            "label": "Hawaii",
            "srids": [
              {
                "name": "NAD83(HARN) / Hawaii zone 1",
                "epsg": 2782
              },
              {
                "name": "NAD83(HARN) / Hawaii zone 2",
                "epsg": 2783
              },
              {
                "name": "NAD83(HARN) / Hawaii zone 3",
                "epsg": 2784
              },
              {
                "name": "NAD83(HARN) / Hawaii zone 4",
                "epsg": 2785
              },
              {
                "name": "NAD83(HARN) / Hawaii zone 5",
                "epsg": 2786
              }
            ]
          },
          "6.1.11": {
            "label": "Idaho",
            "srids": [
              {
                "name": "NAD83(HARN) / Idaho East",
                "epsg": 2787
              },
              {
                "name": "NAD83(HARN) / Idaho Central",
                "epsg": 2788
              },
              {
                "name": "NAD83(HARN) / Idaho West",
                "epsg": 2789
              }
            ]
          },
          "6.1.12": {
            "label": "Illinois",
            "srids": [
              {
                "name": "NAD83(HARN) / Illinois East",
                "epsg": 2790
              },
              {
                "name": "NAD83(HARN) / Illinois West",
                "epsg": 2791
              }
            ]
          },
          "6.1.13": {
            "label": "Indiana",
            "srids": [
              {
                "name": "NAD83(HARN) / Indiana East",
                "epsg": 2792
              },
              {
                "name": "NAD83(HARN) / Indiana West",
                "epsg": 2793
              }
            ]
          },
          "6.1.14": {
            "label": "Iowa",
            "srids": [
              {
                "name": "NAD83(HARN) / Iowa North",
                "epsg": 2794
              },
              {
                "name": "NAD83(HARN) / Iowa South",
                "epsg": 2795
              }
            ]
          },
          "6.1.15": {
            "label": "Kansas",
            "srids": [
              {
                "name": "NAD83(HARN) / Kansas North",
                "epsg": 2796
              },
              {
                "name": "NAD83(HARN) / Kansas South",
                "epsg": 2797
              }
            ]
          },
          "6.1.16": {
            "label": "Kentucky",
            "srids": [
              {
                "name": "NAD83(HARN) / Kentucky North",
                "epsg": 2798
              },
              {
                "name": "NAD83(HARN) / Kentucky South",
                "epsg": 2799
              }
            ]
          },
          "6.1.17": {
            "label": "Louisiana",
            "srids": [
              {
                "name": "NAD83(HARN) / Louisiana North",
                "epsg": 2800
              },
              {
                "name": "NAD83(HARN) / Louisiana South",
                "epsg": 2801
              }
            ]
          },
          "6.1.18": {
            "label": "Maine",
            "srids": [
              {
                "name": "NAD83(HARN) / Maine East",
                "epsg": 2802
              },
              {
                "name": "NAD83(HARN) / Maine West",
                "epsg": 2803
              }
            ]
          },
          "6.1.19": {
            "label": "Maryland",
            "srids": [
              {
                "name": "NAD83(HARN) / Maryland",
                "epsg": 2804
              }
            ]
          },
          "6.1.20": {
            "label": "Massachusetts",
            "srids": [
              {
                "name": "NAD83(HARN) / Massachusetts Mainland",
                "epsg": 2805
              },
              {
                "name": "NAD83(HARN) / Massachusetts Island",
                "epsg": 2806
              }
            ]
          },
          "6.1.21": {
            "label": "Michigan",
            "srids": [
              {
                "name": "NAD83(HARN) / Michigan North",
                "epsg": 2807
              },
              {
                "name": "NAD83(HARN) / Michigan Central",
                "epsg": 2808
              },
              {
                "name": "NAD83(HARN) / Michigan South",
                "epsg": 2809
              }
            ]
          },
          "6.1.22": {
            "label": "Minnesota",
            "srids": [
              {
                "name": "NAD83(HARN) / Minnesota North",
                "epsg": 2810
              },
              {
                "name": "NAD83(HARN) / Minnesota Central",
                "epsg": 2811
              },
              {
                "name": "NAD83(HARN) / Minnesota South",
                "epsg": 2812
              }
            ]
          },
          "6.1.23": {
            "label": "Mississippi",
            "srids": [
              {
                "name": "NAD83(HARN) / Mississippi East",
                "epsg": 2813
              },
              {
                "name": "NAD83(HARN) / Mississippi West",
                "epsg": 2814
              }
            ]
          },
          "6.1.24": {
            "label": "Missouri",
            "srids": [
              {
                "name": "NAD83(HARN) / Missouri East",
                "epsg": 2815
              },
              {
                "name": "NAD83(HARN) / Missouri Central",
                "epsg": 2816
              },
              {
                "name": "NAD83(HARN) / Missouri West",
                "epsg": 2817
              }
            ]
          },
          "6.1.25": {
            "label": "Montana",
            "srids": [
              {
                "name": "NAD83(HARN) / Montana",
                "epsg": 2818
              }
            ]
          },
          "6.1.26": {
            "label": "Nebraska",
            "srids": [
              {
                "name": "NAD83(HARN) / Nebraska",
                "epsg": 2819
              }
            ]
          },
          "6.1.27": {
            "label": "Nevada",
            "srids": [
              {
                "name": "NAD83(HARN) / Nevada East",
                "epsg": 2820
              },
              {
                "name": "NAD83(HARN) / Nevada Central",
                "epsg": 2821
              },
              {
                "name": "NAD83(HARN) / Nevada West",
                "epsg": 2822
              }
            ]
          },
          "6.1.28": {
            "label": "New Hampshire",
            "srids": [
              {
                "name": "NAD83(HARN) / New Hampshire",
                "epsg": 2823
              }
            ]
          },
          "6.1.29": {
            "label": "New Jersey",
            "srids": [
              {
                "name": "NAD83(HARN) / New Jersey",
                "epsg": 2824
              }
            ]
          },
          "6.1.30": {
            "label": "New Mexico",
            "srids": [
              {
                "name": "NAD83(HARN) / New Mexico East",
                "epsg": 2825
              },
              {
                "name": "NAD83(HARN) / New Mexico Central",
                "epsg": 2826
              },
              {
                "name": "NAD83(HARN) / New Mexico West",
                "epsg": 2827
              }
            ]
          },
          "6.1.31": {
            "label": "New York",
            "srids": [
              {
                "name": "NAD83(HARN) / New York East",
                "epsg": 2828
              },
              {
                "name": "NAD83(HARN) / New York Central",
                "epsg": 2829
              },
              {
                "name": "NAD83(HARN) / New York West",
                "epsg": 2830
              },
              {
                "name": "NAD83(HARN) / New York Long Island",
                "epsg": 2831
              }
            ]
          },
          "6.1.32": {
            "label": "North Carolina",
            "srids": [
              {
                "name": "NAD83(HARN) / North Carolina",
                "epsg": 3358
              }
            ]
          },
          "6.1.33": {
            "label": "North Dakota",
            "srids": [
              {
                "name": "NAD83(HARN) / North Dakota North",
                "epsg": 2832
              },
              {
                "name": "NAD83(HARN) / North Dakota South",
                "epsg": 2833
              }
            ]
          },
          "6.1.34": {
            "label": "Ohio",
            "srids": [
              {
                "name": "NAD83(HARN) / Ohio North",
                "epsg": 2834
              },
              {
                "name": "NAD83(HARN) / Ohio South",
                "epsg": 2835
              }
            ]
          },
          "6.1.35": {
            "label": "Oklahoma",
            "srids": [
              {
                "name": "NAD83(HARN) / Oklahoma North",
                "epsg": 2836
              },
              {
                "name": "NAD83(HARN) / Oklahoma South",
                "epsg": 2837
              }
            ]
          },
          "6.1.36": {
            "label": "Oregon",
            "srids": [
              {
                "name": "NAD83(HARN) / Oregon North",
                "epsg": 2838
              },
              {
                "name": "NAD83(HARN) / Oregon South",
                "epsg": 2839
              }
            ]
          },
          "6.1.37": {
            "label": "Pennsylvania",
            "srids": [
              {
                "name": "NAD83(HARN) / Pennsylvania North",
                "epsg": 3362
              },
              {
                "name": "NAD83(HARN) / Pennsylvania North (ftUS)",
                "epsg": 3363
              }
            ]
          },
          "6.1.38": {
            "label": "Rhode Island",
            "srids": [
              {
                "name": "NAD83(HARN) / Rhode Island",
                "epsg": 2840
              }
            ]
          },
          "6.1.39": {
            "label": "South Carolina",
            "srids": [
              {
                "name": "NAD83(HARN) / South Carolina",
                "epsg": 3360
              }
            ]
          },
          "6.1.40": {
            "label": "South Dakota",
            "srids": [
              {
                "name": "NAD83(HARN) / South Dakota North",
                "epsg": 2841
              },
              {
                "name": "NAD83(HARN) / South Dakota South",
                "epsg": 2842
              }
            ]
          },
          "6.1.41": {
            "label": "Tennessee",
            "srids": [
              {
                "name": "NAD83(HARN) / Tennessee",
                "epsg": 2843
              }
            ]
          },
          "6.1.42": {
            "label": "Texas",
            "srids": [
              {
                "name": "NAD83(HARN) / Texas North",
                "epsg": 2844
              },
              {
                "name": "NAD83(HARN) / Texas North Central",
                "epsg": 2845
              },
              {
                "name": "NAD83(HARN) / Texas Central",
                "epsg": 2846
              },
              {
                "name": "NAD83(HARN) / Texas South Central",
                "epsg": 2847
              },
              {
                "name": "NAD83(HARN) / Texas South",
                "epsg": 2848
              }
            ]
          },
          "6.1.43": {
            "label": "Utah",
            "srids": [
              {
                "name": "NAD83(HARN) / Utah North",
                "epsg": 2849
              },
              {
                "name": "NAD83(HARN) / Utah Central",
                "epsg": 2850
              },
              {
                "name": "NAD83(HARN) / Utah South",
                "epsg": 2851
              }
            ]
          },
          "6.1.44": {
            "label": "Vermont",
            "srids": [
              {
                "name": "NAD83(HARN) / Vermont",
                "epsg": 2852
              }
            ]
          },
          "6.1.45": {
            "label": "Virginia",
            "srids": [
              {
                "name": "NAD83(HARN) / Virginia North",
                "epsg": 2853
              },
              {
                "name": "NAD83(HARN) / Virginia South",
                "epsg": 2854
              }
            ]
          },
          "6.1.46": {
            "label": "Washington",
            "srids": [
              {
                "name": "NAD83(HARN) / Washington North",
                "epsg": 2855
              },
              {
                "name": "NAD83(HARN) / Washington South",
                "epsg": 2856
              }
            ]
          },
          "6.1.47": {
            "label": "West Virginia",
            "srids": [
              {
                "name": "NAD83(HARN) / West Virginia North",
                "epsg": 2857
              },
              {
                "name": "NAD83(HARN) / West Virginia South",
                "epsg": 2858
              }
            ]
          },
          "6.1.48": {
            "label": "Wisconsin",
            "srids": [
              {
                "name": "NAD83(HARN) / Wisconsin North",
                "epsg": 2859
              },
              {
                "name": "NAD83(HARN) / Wisconsin Central",
                "epsg": 2860
              },
              {
                "name": "NAD83(HARN) / Wisconsin South",
                "epsg": 2861
              }
            ]
          },
          "6.1.49": {
            "label": "Wyoming",
            "srids": [
              {
                "name": "NAD83(HARN) / Wyoming East",
                "epsg": 2862
              },
              {
                "name": "NAD83(HARN) / Wyoming East Central",
                "epsg": 2863
              },
              {
                "name": "NAD83(HARN) / Wyoming West Central",
                "epsg": 2864
              },
              {
                "name": "NAD83(HARN) / Wyoming West",
                "epsg": 2865
              }
            ]
          },
          "6.1.50": {
            "label": "Puerto Rico / VI",
            "srids": [
              {
                "name": "NAD83(HARN) / Puerto Rico and Virgin Is.",
                "epsg": 2866
              }
            ]
          }
        }
      },
      "6.2": {
        "label": "HARN (US Survey Feet)",
        "srids": [
          {
            "name": "NAD83(HARN) / Arizona East",
            "epsg": 2867
          },
          {
            "name": "NAD83(HARN) / Arizona Central",
            "epsg": 2868
          },
          {
            "name": "NAD83(HARN) / Arizona West",
            "epsg": 2869
          },
          {
            "name": "NAD83(HARN) / California zone 1",
            "epsg": 2870
          },
          {
            "name": "NAD83(HARN) / California zone 2",
            "epsg": 2871
          },
          {
            "name": "NAD83(HARN) / California zone 3",
            "epsg": 2872
          },
          {
            "name": "NAD83(HARN) / California zone 4",
            "epsg": 2873
          },
          {
            "name": "NAD83(HARN) / California zone 5",
            "epsg": 2874
          },
          {
            "name": "NAD83(HARN) / California zone 6",
            "epsg": 2875
          },
          {
            "name": "NAD83(HARN) / Colorado North",
            "epsg": 2876
          },
          {
            "name": "NAD83(HARN) / Colorado Central",
            "epsg": 2877
          },
          {
            "name": "NAD83(HARN) / Colorado South",
            "epsg": 2878
          },
          {
            "name": "NAD83(HARN) / Connecticut",
            "epsg": 2879
          },
          {
            "name": "NAD83(HARN) / Delaware",
            "epsg": 2880
          },
          {
            "name": "NAD83(HARN) / Florida East",
            "epsg": 2881
          },
          {
            "name": "NAD83(HARN) / Florida West",
            "epsg": 2882
          },
          {
            "name": "NAD83(HARN) / Florida North",
            "epsg": 2883
          },
          {
            "name": "NAD83(HARN) / Georgia East",
            "epsg": 2884
          },
          {
            "name": "NAD83(HARN) / Georgia West",
            "epsg": 2885
          },
          {
            "name": "NAD83(HARN) / Idaho East",
            "epsg": 2886
          },
          {
            "name": "NAD83(HARN) / Idaho Central",
            "epsg": 2887
          },
          {
            "name": "NAD83(HARN) / Idaho West",
            "epsg": 2888
          },
          {
            "name": "NAD83(HARN) / Indiana East",
            "epsg": 2889
          },
          {
            "name": "NAD83(HARN) / Indiana West",
            "epsg": 2890
          },
          {
            "name": "NAD83(HARN) / Kentucky North",
            "epsg": 2891
          },
          {
            "name": "NAD83(HARN) / Kentucky South",
            "epsg": 2892
          },
          {
            "name": "NAD83(HARN) / Maryland",
            "epsg": 2893
          },
          {
            "name": "NAD83(HARN) / Massachusetts Mainland",
            "epsg": 2894
          },
          {
            "name": "NAD83(HARN) / Massachusetts Island",
            "epsg": 2895
          },
          {
            "name": "NAD83(HARN) / Michigan North",
            "epsg": 2896
          },
          {
            "name": "NAD83(HARN) / Michigan Central",
            "epsg": 2897
          },
          {
            "name": "NAD83(HARN) / Michigan South",
            "epsg": 2898
          },
          {
            "name": "NAD83(HARN) / Mississippi East",
            "epsg": 2899
          },
          {
            "name": "NAD83(HARN) / Mississippi West",
            "epsg": 2900
          },
          {
            "name": "NAD83(HARN) / Montana",
            "epsg": 2901
          },
          {
            "name": "NAD83(HARN) / New Mexico East",
            "epsg": 2902
          },
          {
            "name": "NAD83(HARN) / New Mexico Central",
            "epsg": 2903
          },
          {
            "name": "NAD83(HARN) / New Mexico West",
            "epsg": 2904
          },
          {
            "name": "NAD83(HARN) / New York East",
            "epsg": 2905
          },
          {
            "name": "NAD83(HARN) / New York Central",
            "epsg": 2906
          },
          {
            "name": "NAD83(HARN) / New York West",
            "epsg": 2907
          },
          {
            "name": "NAD83(HARN) / New York Long Island",
            "epsg": 2908
          },
          {
            "name": "NAD83(HARN) / North Dakota North",
            "epsg": 2909
          },
          {
            "name": "NAD83(HARN) / North Dakota South",
            "epsg": 2910
          },
          {
            "name": "NAD83(HARN) / Oklahoma North",
            "epsg": 2911
          },
          {
            "name": "NAD83(HARN) / Oklahoma South",
            "epsg": 2912
          },
          {
            "name": "NAD83(HARN) / Oregon North",
            "epsg": 2913
          },
          {
            "name": "NAD83(HARN) / Oregon South",
            "epsg": 2914
          },
          {
            "name": "NAD83(HARN) / Tennessee",
            "epsg": 2915
          },
          {
            "name": "NAD83(HARN) / Texas North",
            "epsg": 2916
          },
          {
            "name": "NAD83(HARN) / Texas North Central",
            "epsg": 2917
          },
          {
            "name": "NAD83(HARN) / Texas Central",
            "epsg": 2918
          },
          {
            "name": "NAD83(HARN) / Texas South Central",
            "epsg": 2919
          },
          {
            "name": "NAD83(HARN) / Texas South",
            "epsg": 2920
          },
          {
            "name": "NAD83(HARN) / Utah North",
            "epsg": 2921
          },
          {
            "name": "NAD83(HARN) / Utah Central",
            "epsg": 2922
          },
          {
            "name": "NAD83(HARN) / Utah South",
            "epsg": 2923
          },
          {
            "name": "NAD83(HARN) / Virginia North",
            "epsg": 2924
          },
          {
            "name": "NAD83(HARN) / Virginia South",
            "epsg": 2925
          },
          {
            "name": "NAD83(HARN) / Washington North",
            "epsg": 2926
          },
          {
            "name": "NAD83(HARN) / Washington South",
            "epsg": 2927
          },
          {
            "name": "NAD83(HARN) / Wisconsin North",
            "epsg": 2928
          },
          {
            "name": "NAD83(HARN) / Wisconsin Central",
            "epsg": 2929
          },
          {
            "name": "NAD83(HARN) / Wisconsin South",
            "epsg": 2930
          }
        ]
      }
    }
  },
  "8": {
    "label": "WORLD PROJECTIONS",
    "srids": [
      {
        "name": "WGS 84 / Pseudo-Mercator",
        "epsg": 3857
      },
      {
        "name": "WGS 84 / World Mercator",
        "epsg": 3395
      },
      {
        "name": "World_Robinson",
        "epsg": 54030
      },
      {
        "name": "World_Sinusoidal",
        "epsg": 54008
      },
      {
        "name": "World_Mollweide",
        "epsg": 54009
      },
      {
        "name": "World_Eckert_IV",
        "epsg": 54012
      },
      {
        "name": "World_Equidistant_Cylindrical",
        "epsg": 54002
      },
      {
        "name": "World_Cylindrical_Equal_Area",
        "epsg": 54034
      },
      {
        "name": "WGS 84 / Plate Carree",
        "epsg": 32662
      }
    ]
  },
  "9": {
    "label": "INTERNATIONAL NATIONAL GRIDS",
    "srids": [
      {
        "name": "OSGB36 / British National Grid",
        "epsg": 27700
      },
      {
        "name": "TM65 / Irish Grid",
        "epsg": 29902
      },
      {
        "name": "IRENET95 / Irish Transverse Mercator",
        "epsg": 2157
      },
      {
        "name": "RGF93 v1 / Lambert-93",
        "epsg": 2154
      },
      {
        "name": "NTF / Lambert Nord",
        "epsg": 27561
      },
      {
        "name": "NTF / Lambert Centre",
        "epsg": 27562
      },
      {
        "name": "NTF / Lambert Sud",
        "epsg": 27563
      },
      {
        "name": "NTF / Lambert Corse",
        "epsg": 27564
      },
      {
        "name": "DHDN / GK zone 2",
        "epsg": 31466
      },
      {
        "name": "DHDN / GK zone 3",
        "epsg": 31467
      },
      {
        "name": "DHDN / GK zone 4",
        "epsg": 31468
      },
      {
        "name": "DHDN / GK zone 5",
        "epsg": 31469
      },
      {
        "name": "CH1903 / LV03",
        "epsg": 21781
      },
      {
        "name": "CH1903+ / LV95",
        "epsg": 2056
      },
      {
        "name": "Amersfoort / RD New",
        "epsg": 28992
      },
      {
        "name": "BD72 / Belgian Lambert 72",
        "epsg": 31370
      },
      {
        "name": "SWEREF99 TM",
        "epsg": 3006
      },
      {
        "name": "EUREF-FIN / TM35FIN(E,N)",
        "epsg": 3067
      },
      {
        "name": "HD72 / EOV",
        "epsg": 23700
      },
      {
        "name": "S-JTSK / Krovak East North",
        "epsg": 5514
      },
      {
        "name": "Monte Mario / Italy zone 1",
        "epsg": 3003
      },
      {
        "name": "Monte Mario / Italy zone 2",
        "epsg": 3004
      },
      {
        "name": "ED50 / UTM zone 28N",
        "epsg": 23028
      },
      {
        "name": "ED50 / UTM zone 29N",
        "epsg": 23029
      },
      {
        "name": "ED50 / UTM zone 30N",
        "epsg": 23030
      },
      {
        "name": "ED50 / UTM zone 31N",
        "epsg": 23031
      },
      {
        "name": "ETRS89 / Portugal TM06",
        "epsg": 3763
      },
      { "name": "Datum 73", "epsg": 4274 },
      { "name": "Datum 73 / UTM zone 29N", "epsg": 27429 },
      { "name": "Datum 73 / Modified Portuguese Grid", "epsg": 27493 },
      { "name": "Datum 73 (deg)", "epsg": 62746405 },
      { "name": "Datum 73 / Modified Portuguese Grid", "epsg": 27492 },
      {
        "name": "Pulkovo 1942 / GK zone 2",
        "epsg": 28402
      },
      {
        "name": "Pulkovo 1942 / GK zone 3",
        "epsg": 28403
      },
      {
        "name": "Pulkovo 1942 / GK zone 4",
        "epsg": 28404
      },
      {
        "name": "Pulkovo 1942 / GK zone 5",
        "epsg": 28405
      },
      {
        "name": "Pulkovo 1942 / GK zone 6",
        "epsg": 28406
      },
      {
        "name": "Pulkovo 1942 / GK zone 7",
        "epsg": 28407
      },
      {
        "name": "Pulkovo 1942 / GK zone 8",
        "epsg": 28408
      },
      {
        "name": "Pulkovo 1942 / GK zone 9",
        "epsg": 28409
      },
      {
        "name": "Pulkovo 1942 / GK zone 10",
        "epsg": 28410
      },
      {
        "name": "Pulkovo 1942 / GK zone 11",
        "epsg": 28411
      },
      {
        "name": "Pulkovo 1942 / GK zone 12",
        "epsg": 28412
      },
      {
        "name": "Pulkovo 1942 / GK zone 13",
        "epsg": 28413
      },
      {
        "name": "Pulkovo 1942 / GK zone 14",
        "epsg": 28414
      },
      {
        "name": "Pulkovo 1942 / GK zone 15",
        "epsg": 28415
      },
      {
        "name": "Pulkovo 1942 / GK zone 16",
        "epsg": 28416
      },
      {
        "name": "Pulkovo 1942 / GK zone 17",
        "epsg": 28417
      },
      {
        "name": "Pulkovo 1942 / GK zone 18",
        "epsg": 28418
      },
      {
        "name": "Pulkovo 1942 / GK zone 19",
        "epsg": 28419
      },
      {
        "name": "Pulkovo 1942 / GK zone 20",
        "epsg": 28420
      },
      {
        "name": "Pulkovo 1942 / GK zone 21",
        "epsg": 28421
      },
      {
        "name": "Pulkovo 1942 / GK zone 22",
        "epsg": 28422
      },
      {
        "name": "Pulkovo 1942 / GK zone 23",
        "epsg": 28423
      },
      {
        "name": "Pulkovo 1942 / GK zone 24",
        "epsg": 28424
      },
      {
        "name": "Pulkovo 1942 / GK zone 25",
        "epsg": 28425
      },
      {
        "name": "Pulkovo 1942 / GK zone 26",
        "epsg": 28426
      },
      {
        "name": "Pulkovo 1942 / GK zone 27",
        "epsg": 28427
      },
      {
        "name": "Pulkovo 1942 / GK zone 28",
        "epsg": 28428
      },
      {
        "name": "Pulkovo 1942 / GK zone 29",
        "epsg": 28429
      },
      {
        "name": "Pulkovo 1942 / GK zone 30",
        "epsg": 28430
      },
      {
        "name": "Pulkovo 1942 / GK zone 31",
        "epsg": 28431
      },
      {
        "name": "Pulkovo 1942 / GK zone 32",
        "epsg": 28432
      },
      {
        "name": "JGD2000 / Japan Plane zone 1",
        "epsg": 2443
      },
      {
        "name": "JGD2000 / Japan Plane zone 2",
        "epsg": 2444
      },
      {
        "name": "JGD2000 / Japan Plane zone 3",
        "epsg": 2445
      },
      {
        "name": "JGD2000 / Japan Plane zone 4",
        "epsg": 2446
      },
      {
        "name": "JGD2000 / Japan Plane zone 5",
        "epsg": 2447
      },
      {
        "name": "JGD2000 / Japan Plane zone 6",
        "epsg": 2448
      },
      {
        "name": "JGD2000 / Japan Plane zone 7",
        "epsg": 2449
      },
      {
        "name": "JGD2000 / Japan Plane zone 8",
        "epsg": 2450
      },
      {
        "name": "JGD2000 / Japan Plane zone 9",
        "epsg": 2451
      },
      {
        "name": "JGD2000 / Japan Plane zone 10",
        "epsg": 2452
      },
      {
        "name": "JGD2000 / Japan Plane zone 11",
        "epsg": 2453
      },
      {
        "name": "JGD2000 / Japan Plane zone 12",
        "epsg": 2454
      },
      {
        "name": "JGD2000 / Japan Plane zone 13",
        "epsg": 2455
      },
      {
        "name": "JGD2000 / Japan Plane zone 14",
        "epsg": 2456
      },
      {
        "name": "JGD2000 / Japan Plane zone 15",
        "epsg": 2457
      },
      {
        "name": "JGD2000 / Japan Plane zone 16",
        "epsg": 2458
      },
      {
        "name": "JGD2000 / Japan Plane zone 17",
        "epsg": 2459
      },
      {
        "name": "JGD2000 / Japan Plane zone 18",
        "epsg": 2460
      },
      {
        "name": "JGD2000 / Japan Plane zone 19",
        "epsg": 2461
      },
      {
        "name": "GDA94 / MGA zone 49",
        "epsg": 28349
      },
      {
        "name": "GDA94 / MGA zone 50",
        "epsg": 28350
      },
      {
        "name": "GDA94 / MGA zone 51",
        "epsg": 28351
      },
      {
        "name": "GDA94 / MGA zone 52",
        "epsg": 28352
      },
      {
        "name": "GDA94 / MGA zone 53",
        "epsg": 28353
      },
      {
        "name": "GDA94 / MGA zone 54",
        "epsg": 28354
      },
      {
        "name": "GDA94 / MGA zone 55",
        "epsg": 28355
      },
      {
        "name": "GDA94 / MGA zone 56",
        "epsg": 28356
      },
      {
        "name": "GDA2020 / MGA zone 49",
        "epsg": 7849
      },
      {
        "name": "GDA2020 / MGA zone 50",
        "epsg": 7850
      },
      {
        "name": "GDA2020 / MGA zone 51",
        "epsg": 7851
      },
      {
        "name": "GDA2020 / MGA zone 52",
        "epsg": 7852
      },
      {
        "name": "GDA2020 / MGA zone 53",
        "epsg": 7853
      },
      {
        "name": "GDA2020 / MGA zone 54",
        "epsg": 7854
      },
      {
        "name": "GDA2020 / MGA zone 55",
        "epsg": 7855
      },
      {
        "name": "GDA2020 / MGA zone 56",
        "epsg": 7856
      },
      {
        "name": "NZGD2000 / New Zealand Transverse Mercator 2000",
        "epsg": 2193
      },
      { "name": "Hartebeesthoek94", "epsg": 4941 },
      { "name": "Hartebeesthoek94", "epsg": 4148 },
      { "name": "Hartebeesthoek94", "epsg": 4940 },
      { "name": "Hartebeesthoek94 / Lo15", "epsg": 2046 },
      { "name": "Hartebeesthoek94 / Lo17", "epsg": 2047 },
      { "name": "Hartebeesthoek94 / Lo19", "epsg": 2048 },
      { "name": "Hartebeesthoek94 / Lo21", "epsg": 2049 },
      { "name": "Hartebeesthoek94 / Lo23", "epsg": 2050 },
      { "name": "Hartebeesthoek94 / Lo25", "epsg": 2051 },
      { "name": "Hartebeesthoek94 / Lo27", "epsg": 2052 },
      { "name": "Hartebeesthoek94 / Lo29", "epsg": 2053 },
      { "name": "Hartebeesthoek94 / Lo31", "epsg": 2054 },
      { "name": "Hartebeesthoek94 / Lo33", "epsg": 2055 },
      { "name": "Hartebeesthoek94 / ZAF BSU Albers 25E", "epsg": 9221 },
      { "name": "Hartebeesthoek94 / ZAF BSU Albers 44E", "epsg": 9222 },
      { "name": "Hartebeesthoek94 (3D)", "epsg": 4349 },
      { "name": "Hartebeesthoek94 (deg)", "epsg": 61486405 },
      { "name": "Hartebeesthoek94 (geocentric)", "epsg": 4350 },
      { "name": "Hartebeesthoek94 (3D deg)", "epsg": 61486413 },
      { "name": "La Canoa", "epsg": 4247 },
      { "name": "La Canoa / UTM zone 18N", "epsg": 24718 },
      { "name": "La Canoa / UTM zone 19N", "epsg": 24719 },
      { "name": "La Canoa / UTM zone 20N", "epsg": 24720 },
      { "name": "La Canoa (deg)", "epsg": 62476405 },
      {
        "name": "Corrego Alegre / Brazil zone 21",
        "epsg": 22521
      },
      {
        "name": "Corrego Alegre / Brazil zone 22",
        "epsg": 22522
      },
      {
        "name": "Corrego Alegre / Brazil zone 23",
        "epsg": 22523
      },
      {
        "name": "Corrego Alegre / Brazil zone 24",
        "epsg": 22524
      },
      {
        "name": "Corrego Alegre / Brazil zone 25",
        "epsg": 22525
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 77",
        "epsg": 31977
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 78",
        "epsg": 31978
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 79",
        "epsg": 31979
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 80",
        "epsg": 31980
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 81",
        "epsg": 31981
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 82",
        "epsg": 31982
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 83",
        "epsg": 31983
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 84",
        "epsg": 31984
      },
      {
        "name": "SIRGAS 2000 / Brazil zone 85",
        "epsg": 31985
      }
    ]
  }
};

export const defaultSrid = projections["1"].groups["1.1"].srids[0];